import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=dd8e707a&"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=ts&"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=ts&"
import style0 from "../assets/css/components/markdown.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports